import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  APPOINTMENT_ZONE,
  ROLE,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { allDoctors, Details, Edit } from "../../services/doctor.services";
import { GetAllCenters, GetAllCentersWithDoctor } from "../../services/usermgmt.services";
import { getDateWithTime } from "../../../../utils/commonfunction";
import { useParams } from "react-router-dom";
import { DatePicker, Drawer } from "rsuite";
// import { editAppointments, getAllPatient, getAppointments } from "../../../doctor/services/patient.services";
import Select from 'react-select';
import moment from "moment";


const AppointmentEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [centers, setCenters] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Appointments"),
      url: "/admin/appointment/list/1",
    },
    { title: t("admin.cafes.link_edit"), url: "" },
  ];

  useEffect(() => {
    GetAllCentersWithDoctor()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  // useEffect(() => {
  //   getAllPatient(ROLE.SUPER_ADMIN)
  //     .then((data) => {
  //       setPatients(data && data.data ? data.data : []);
  //     })
  //     .catch((error) => {
  //       console.log("error ====> ", error);
  //     });
  // }, []);

  // useEffect(() => {
  //   const formData = new FormData()
  //   formData.append("appointment_id", params?.id)
  //   getAppointments(formData, ROLE.SUPER_ADMIN)
  //     .then((response) => {
  //       setShowDefault(response && response.data ? response.data : []);
  //     })
  //     .catch((error) => {
  //       console.log("error=====>", error);
  //     });
  // }, [params.id]);

  const handleStartTimeChange = (e) => {
    editForm.setFieldTouched('startTime', true);
    const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
    if (match && match[0]) {
      const parts = match[0].split(':');
      const hours = parts[0];
      const minutes = parts[1];
      const seconds = parts[2] || '00';
      editForm.setFieldValue('startTime', `${hours}:${minutes}:${seconds}`);
    }
  };

  const validationSchema = Yup.object().shape({
    // appointment_date: Yup.string().required("Appointment date is required"),
    appointment_date: Yup.string()
      .required('Appointment date is required')
      .test('is-future-date', 'Appointment date cannot be in the past', function (value) {
        if (!value) return false;
        const today = moment().startOf('day');
        const selectedDate = moment(value, 'YYYY-MM-DD');
        return selectedDate.isSameOrAfter(today);
      }),
    center: Yup.string()
      .trim()
      .required("Centre is required"),
    doctor: Yup.string()
      .trim()
      .required("Doctor is required"),
    patient: Yup.string()
      .trim()
      .required("Patient is required"),
    major_concern: Yup.string()
      .trim()
      .required("Major concern is required"),
    startTime: Yup.string()
      .trim()
      .required("Start time is required"),
  });


  const editForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      appointment_date: showdefault && showdefault.appointment_date ? showdefault.appointment_date : "",
      center: showdefault && showdefault.center_id ? showdefault.center_id : "",
      doctor: showdefault && showdefault.doctor_id ? showdefault.doctor_id : "",
      patient: showdefault && showdefault.patient_id ? showdefault.patient_id : "",
      startTime: showdefault && showdefault.start_time ? showdefault.start_time : "",
      major_concern: showdefault && showdefault.major_concern ? showdefault.major_concern : "",
      appointment_zone: showdefault && showdefault.appointment_zone ? showdefault.appointment_zone : "",
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    // onSubmit: (values, { setSubmitting, resetForm }) => {
    //   globalLoader(true);
    //   setSubmitted(true);
    //   let formData = new FormData();
    //   formData.append("appointment_id", showdefault._id);
    //   formData.append("appointment_date", values.appointment_date);
    //   formData.append("center_id", values.center);
    //   formData.append("doctor_id", values.doctor);
    //   formData.append("patient_id", values.patient);
    //   formData.append("start_time", values.startTime);
    //   formData.append("major_concern", values.major_concern);
    //   formData.append("appointment_zone", values.appointment_zone);
    //   // formData.append("patient_id", patientData);
    //   editAppointments(formData, ROLE.SUPER_ADMIN)
    //     .then((response) => {
    //       setSubmitting(false);
    //       if (response.success) {
    //         Swal.fire({
    //           icon: "success",
    //           text: response.message,
    //           ...SWAL_SETTINGS,
    //         });
    //         globalLoader(false);
    //         resetForm({ values: "" });
    //         navigate(`/admin/appointment/list/1`);
    //       } else {
    //         Swal.fire({
    //           icon: "error",
    //           text: handleServerValidations(response),
    //           ...SWAL_SETTINGS,
    //         });
    //         globalLoader(false);
    //         setSubmitted(false);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("error ====> ", error);
    //     });
    // },
  });

  useEffect(() => {
    if (editForm?.values?.center) {
      const formData = new FormData();
      formData.append("center_id", editForm.values.center);
      allDoctors(formData, ROLE.SUPER_ADMIN)
        .then((data) => {
          if (data && data.data) {
            setDoctors(data?.data || []);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    }
  }, [editForm?.values?.center]);

  const centerOptions = centers.map((item) => ({
    value: item._id,
    label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
  }));

  const doctorOptions = doctors.map((item) => ({
    value: item._id,
    label: capitalizeFirstLetter(item.name)
  }));

  const patientOptions = patients.map((item) => ({
    value: item._id,
    label: `${capitalizeFirstLetter(item.name)} (${item.patient_register_id})`
  }));

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={editForm.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div className="row row-sm">
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Appointment Date")}:
                      <span className="requirestar">*</span>
                    </label>
                    <DatePicker
                      oneTap={true}
                      editable={false}
                      classPrefix="restaurant"
                      placeholder={t("Enter appointment date")}
                      placement="autoVertical"
                      format="dd.MM.yyyy"
                      cleanable={false}
                      name="appointment_date"
                      // onChange={(e) => {
                      //   editForm.setFieldTouched('appointment_date', true);
                      //   editForm.setFieldValue("appointment_date", e);
                      // }}
                      onChange={(e) => {
                        editForm.setFieldTouched('appointment_date', true);
                        const formattedDate = e.toISOString().split('T')[0];
                        editForm.setFieldValue("appointment_date", formattedDate);
                      }}
                      value={new Date(editForm.values.appointment_date) || new Date()}
                      onBlur={editForm.handleBlur}
                      shouldDisableDate={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        return date < today;
                      }}
                    />
                    <CustomError name="appointment_date" form={editForm} className="text-danger d-flex text-left" />
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Center
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='center' value={editForm?.values?.center} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {centers.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.center_name)}{item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}</option>) })}
                    </select>
                    {editForm.touched.center && editForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.center)}</div>
                    ) : null}
                  </div> */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Centre:
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="center"
                      options={centerOptions}
                      value={centerOptions.find(option => option.value === editForm.values.center)}
                      onChange={selectedOption => editForm.setFieldValue('center', selectedOption?.value)}
                      onBlur={() => editForm.setFieldTouched('center', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No centres found")}
                    />

                    {editForm.touched.center && editForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.center)}</div>
                    ) : null}
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Doctor
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='doctor' value={editForm?.values?.doctor} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {doctors.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.name)}</option>) })}
                    </select>
                    {editForm.touched.doctor && editForm.errors.doctor ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.doctor)}</div>
                    ) : null}
                  </div> */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Doctor:
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="doctor"
                      options={doctorOptions}
                      value={doctorOptions.find(option => option.value === editForm.values.doctor)}
                      onChange={selectedOption => editForm.setFieldValue('doctor', selectedOption?.value)}
                      onBlur={() => editForm.setFieldTouched('doctor', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No doctors found")}
                    />

                    {editForm.touched.doctor && editForm.errors.doctor ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.doctor)}</div>
                    ) : null}
                  </div>
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Patient
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='patient' value={editForm?.values?.patient} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {patients.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.name)}({item?.patient_register_id})</option>) })}
                    </select>
                    {editForm.touched.patient && editForm.errors.patient ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.patient)}</div>
                    ) : null}
                  </div> */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Patient:
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="patient"
                      options={patientOptions}
                      value={patientOptions.find(option => option.value === editForm.values.patient)}
                      onChange={selectedOption => editForm.setFieldValue('patient', selectedOption?.value)}
                      onBlur={() => editForm.setFieldTouched('patient', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No patients found")}
                    />

                    {editForm.touched.patient && editForm.errors.patient ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.patient)}</div>
                    ) : null}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="title" className="text-left d-flex">
                      {t("Major Concern")}:<span className="requirestar">*</span>
                    </label>
                    <textarea
                      name="major_concern"
                      id="major_concern"
                      type="text"
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                      value={editForm.values.major_concern}
                      className="form-control"
                      placeholder={t("Enter major concern")}
                    />
                    {editForm.touched.major_concern && editForm.errors.major_concern ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.major_concern)}</div>
                    ) : null}
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                      </div>
                      <div className="col-md-6">
                        <label className="text-left d-flex">
                          Start Time:
                          <span className="requirestar">*</span>
                        </label>
                        <div className="mb-3">
                          <DatePicker
                            classPrefix="restaurant"
                            placement="autoVertical"
                            format="HH:mm"
                            cleanable={false}
                            editable={true}
                            name="openingTime"
                            onChange={handleStartTimeChange}
                            value={getDateWithTime(editForm.values.startTime)}
                            onBlur={editForm.handleBlur}
                            hideMinutes={(minute) => minute % 15 !== 0}
                          />
                          <CustomError name="startTime" form={editForm} className="text-danger d-flex text-left" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Appointment Zone:
                    </label>
                    <select className="form-control form-select cp" name='appointment_zone' value={editForm?.values?.appointment_zone} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {APPOINTMENT_ZONE.map((item) => (
                        <option key={item.value} value={item.value}>
                          {capitalizeFirstLetter(item.label)}
                        </option>
                      ))}
                    </select>
                    {/* {addForm.touched.doctor && addForm.errors.doctor ? (
                                        <div className="text-danger d-flex text-left">{t(addForm.errors.doctor)}</div>
                                      ) : null} */}
                  </div>
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AppointmentEdit;